import { Link } from 'react-router-dom'
import { compactCustomerName, customerInitials, formatCustomerName } from '@/lib/customer-name'
import { salesSourceCustomerKey, type SalesSourceId } from '@/lib/sales-sources'

export function CustomerBadge({
  customerId,
  sourceId,
  name,
  city,
  phone,
  compact = false,
  onNavigate,
}: {
  customerId: string
  sourceId?: SalesSourceId
  name: string
  city?: string
  phone?: string
  compact?: boolean
  onNavigate?: (event: React.MouseEvent) => void
}) {
  const displayName = compactCustomerName(name)
  const routeIdentity = sourceId ? salesSourceCustomerKey(sourceId, customerId) : customerId
  return (
    <Link
      to={`/customers/${encodeURIComponent(routeIdentity)}`}
      aria-label={`Открыть покупателя ${formatCustomerName(name)}`}
      onClick={(event) => {
        event.stopPropagation()
        onNavigate?.(event)
      }}
      className={`group/customer inline-flex min-w-0 items-center gap-2 rounded-md border border-transparent hover:border-gold/30 hover:bg-gold/5 transition-colors ${compact ? 'px-1.5 py-1 -mx-1.5' : 'px-2 py-1.5 -mx-2'}`}
      title={`${formatCustomerName(name)} · открыть покупателя`}
    >
      <span className={`${compact ? 'size-6 text-[9px]' : 'size-8 text-[11px]'} shrink-0 rounded-full bg-onyx text-ivory inline-flex items-center justify-center font-semibold`}>
        {customerInitials(name)}
      </span>
      <span className="min-w-0">
        <span className={`${compact ? 'text-[11px]' : 'text-[13px]'} block font-semibold text-ink truncate group-hover/customer:text-gold-deep`}>
          {displayName}
        </span>
        {(city || phone) && <span className="block text-[9px] text-ink-faint truncate">{[city, phone].filter(Boolean).join(' · ')}</span>}
      </span>
      <span className="text-ink-faint group-hover/customer:text-gold-deep">›</span>
    </Link>
  )
}
